module.exports = __webpack_public_path__ + "static/media/indian-who-we-are-hero-lg.03ec7d71.jpg";